import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const wixStyleReactEnvironmentProviderDriverFactory = (base, body) => {
  return {
    ...baseUniDriverFactory(base, body),
  };
};
